<template>
  <div v-if="loading">
    <div style="text-align:center; margin:100px;">
      <font-awesome-icon icon="cog" spin size="5x"></font-awesome-icon>
      <p>This may take a while</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: ['loading']
};
</script>

<style scoped>

</style>